const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class InvoiceService {
  getAuthToken() {
    return localStorage.getItem('token');
  }

  getHeaders() {
    const token = this.getAuthToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  // Obtener todas las facturas
  async getInvoices(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.paymentStatus) queryParams.append('paymentStatus', params.paymentStatus);
      if (params.client) queryParams.append('client', params.client);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.search) queryParams.append('search', params.search);

      const response = await fetch(`${API_BASE_URL}/api/invoices?${queryParams}`, {
        method: 'GET',
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en getInvoices:', error);
      throw error;
    }
  }

  // Obtener factura por ID
  async getInvoiceById(invoiceId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/invoices/${invoiceId}`, {
        method: 'GET',
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en getInvoiceById:', error);
      throw error;
    }
  }

  // Obtener facturas por servicio
  async getInvoicesByService(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.serviceId) queryParams.append('serviceId', params.serviceId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.search) queryParams.append('search', params.search);

      const response = await fetch(`${API_BASE_URL}/api/invoices/by-service?${queryParams}`, {
        method: 'GET',
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en getInvoicesByService:', error);
      throw error;
    }
  }

  // Crear factura desde venta
  async createInvoiceFromSale(saleId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/invoices/from-sale/${saleId}`, {
        method: 'POST',
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en createInvoiceFromSale:', error);
      throw error;
    }
  }

  // Actualizar factura
  async updateInvoice(invoiceId, invoiceData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/invoices/${invoiceId}`, {
        method: 'PUT',
        headers: this.getHeaders(),
        body: JSON.stringify(invoiceData),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en updateInvoice:', error);
      throw error;
    }
  }

  // Marcar factura como pagada
  async markInvoiceAsPaid(invoiceId, paymentMethod = 'CASH') {
    try {
      const response = await fetch(`${API_BASE_URL}/api/invoices/${invoiceId}/mark-paid`, {
        method: 'PATCH',
        headers: this.getHeaders(),
        body: JSON.stringify({ paymentMethod }),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en markInvoiceAsPaid:', error);
      throw error;
    }
  }

  // Registrar abono/pago parcial
  async addPayment(invoiceId, paymentData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/invoices/${invoiceId}/payments`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(paymentData),
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en addPayment:', error);
      throw error;
    }
  }

  // Obtener estadísticas de facturas
  async getInvoiceStats(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);

      const response = await fetch(`${API_BASE_URL}/api/invoices/stats?${queryParams}`, {
        method: 'GET',
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en getInvoiceStats:', error);
      throw error;
    }
  }
}

export default new InvoiceService();
